// src/config/aws-config.js
const awsConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
      authenticationFlowType: "USER_SRP_AUTH",
      loginWith: {
        email: true,
        username: false
      },
      oauth: {
        scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      }
    },
  },
};

// Debug logging to verify environment variables are loaded
console.log('🔧 AWS Config Environment Variables:', {
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  clientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  nodeEnv: process.env.NODE_ENV
});

console.log('🔧 Final AWS Config being used:', awsConfig);

export default awsConfig;